// Картата на една фактура на телефон. Общата транспозиция „ред на колона" би
// направила от единадесет колони карта от единадесет реда — тук първият ред
// носи това, което човек търси: чия е фактурата и за колко е.
//
// Анулираната си личи и тук: зачертан номер + червен чип. Тонът на реда
// (`rowTone`) на телефона не се вижда — картите нямат фон по ред.

import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { EM_DASH } from "../../../../components/dataTable";
import type { InvoiceRow } from "./invoicesMath";

type Props = { row: InvoiceRow };

export const InvoiceMobileCard = ({ row }: Props) => {
  const { t } = useTranslation();
  const issueDate = dayjs(row.issueDate);

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <span
          className={`shrink-0 font-pos-mono text-[13px] font-bold tabular-nums ${
            row.isCancelled
              ? "text-danger-ink line-through"
              : "text-brand-deep-ink"
          }`}
        >
          {row.number}
        </span>
        <span className="min-w-0 flex-1 truncate text-[15px] font-bold text-ink">
          {row.customerName || EM_DASH}
        </span>
        <span className="font-pos-mono text-[15px] font-bold tabular-nums text-ink">
          {fmtEuro(row.grandTotal)}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12px] font-medium text-muted">
        <span className="font-pos-mono tabular-nums">
          {issueDate.isValid() ? issueDate.format("DD.MM.YYYY") : EM_DASH}
        </span>
        {row.customerEik ? (
          <>
            <span aria-hidden>·</span>
            <span className="font-pos-mono tabular-nums">
              {row.customerEik}
            </span>
          </>
        ) : null}
        <span aria-hidden>·</span>
        <span>{row.typeLabel}</span>
      </div>

      <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[12px] font-medium text-soft">
        <span className="font-pos-mono tabular-nums">
          {`${t("invoicesReport.colTaxable")} ${fmtEuro(row.taxable)}`}
        </span>
        <span aria-hidden>·</span>
        <span className="font-pos-mono tabular-nums">
          {`${t("invoicesReport.colVat")} ${fmtEuro(row.vat)}`}
        </span>
        {row.isCancelled ? (
          <span className="rounded-md bg-danger-tint px-2 py-[3px] text-[11px] font-bold leading-[normal] text-danger-ink">
            {row.statusLabel}
          </span>
        ) : null}
      </div>
    </div>
  );
};
